import { Injectable } from '@angular/core';
import {
    Router,
    NavigationStart
} from '@angular/router';
import { Restangular } from 'ngx-restangular';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class NavigationService {
    private subject = new Subject<any>();

    constructor(private router: Router) {
        // clear alert message on route change
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                var path = event.url.split('/');
                let moduleName = path[1];
                let page = path[2];

                let pageInfo = {
                    module: moduleName,
                    page: page,
                    link: event.url
                };

                this.populatePageLinks(pageInfo);
            }
        });
    }

    populatePageLinks(message: any) {
        this.subject.next(message);
    }

    getLinks(): Observable<any> {
        return this.subject.asObservable();
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/services/navigation.service.ts